import { Button } from "@material-ui/core";
import clsx from "clsx";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import ProcessComplete from "./ProcessCompleted";
import ProcessInProgress from "./ProcessInProgress";

type Props = {
  progress: number;
  isOpen?: boolean;
  isComplete: boolean;
  onClose?: () => void;
  completedClickHandler?: () => void;
  cancelClickHandler?: () => void;
  statusText: string;
  downloadText: string;
};
const useStyles = makeThemedStyles("ProgressModal", (theme) => ({
  dialog: {
    borderRadius: "30px",
    backgroundColor: "rgba(155, 220, 230, 0.3)",
  },
  modalContainer: {
    top: "20vh",
    bottom: "20vh",
    left: "20vw",
    right: "20vw",
    position: "absolute",
    background: "rgba(255, 255, 255, 1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "30px",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  processText: {
    marginTop: "1.875em",
    fontWeight: 400,
    fontSize: "1.82em",
    lineHeight: "1.75em",
    color: "rgba(17, 94, 103, 1)",
    marginLeft: "3em",
    marginRight: "3em",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginBottom: "30px",
    position: "absolute",
    bottom: "0px",
  },
  button: {
    marginTop: "3.37em",
    borderRadius: "2.971em",
    padding: "6px 16px",
  },
  cancel: {
    width: "24.28em",
    height: "5.57em",
    background: "#0e9cf003",
  },
  downloadBtn: {
    width: "200px",
    height: "40px",
    background: "#0e9cf002",
  },
  label: {
    fontSize: "16px",
    lineHeight: "27.01px",
    fontWeight: 400,
    letterSpacing: "0.005px",
    color: "#0e9cf0",
  },
  downloadLabel: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "27px",
    letterSpacing: "0.05px",
    color: "#0e9cf0",
  },
  textCompleted: {
    marginTop: "18px",
    textTransform: "capitalize",
  },
}));
const ProgressDashboardExportModal = (props: Props) => {
  const classes = useStyles();
  const {
    progress,
    completedClickHandler,
    cancelClickHandler,
    isComplete,
    statusText,
    downloadText,
  } = props;
  return (
    <div className={classes.modalContainer}>
      <div className={classes.contentContainer}>
        {isComplete ? (
          <ProcessComplete />
        ) : (
          <ProcessInProgress progress={progress} />
        )}

        <div
          className={clsx(classes.processText, {
            [classes.textCompleted]: isComplete,
          })}
        >
          {statusText}
        </div>
      </div>

      <div className={classes.actionContainer}>
        <Button
          classes={{
            root: clsx(classes.button, {
              [classes.cancel]: !isComplete,
              [classes.downloadBtn]: isComplete,
            }),
            label: clsx({
              [classes.label]: !isComplete,
              [classes.downloadLabel]: isComplete,
            }),
          }}
          onClick={isComplete ? completedClickHandler : cancelClickHandler}
        >
          {isComplete ? downloadText : "Cancel Request"}
        </Button>
      </div>
    </div>
  );
};

export default ProgressDashboardExportModal;
